import { useHistory } from "react-router-dom";
import { goBackInApp } from "../../app/utils/backNavigation";
import { useCurrentUser } from "../../user/hooks/useCurrentUser";
import { sharedContentBackDestination } from "../utils/roomContentPath";
import { useCanOpenRoom } from "./useCanOpenRoom";

/**
 * The Back handler of a shared room resource page: a video, a video story, an
 * infographic, a podcast.
 *
 * The page before, when the app has one. Otherwise the destination that
 * `sharedContentBackDestination` gives: `/` for a signed-out reader, the room
 * for a reader who can open it, `/` for a reader the room refuses. These pages
 * open from a cold link now (`docs/shared-content-access/README.md`), and
 * `history.goBack()` from a cold link leaves the app or does nothing.
 */
export function useSharedContentBack(roomId: string | null): () => void {
  const history = useHistory();
  const { isAuthenticated } = useCurrentUser();
  const canOpenRoom = useCanOpenRoom(roomId);

  return () => {
    goBackInApp(
      history,
      sharedContentBackDestination(
        isAuthenticated
          ? { kind: "signed-in", roomId, hasRoom: canOpenRoom === "open" }
          : { kind: "signed-out" }
      )
    );
  };
}
